import { useEffect, useRef, useState } from "react";
import useReveal from "../hooks/useReveal";

const STATS = [
    { value: 12, suffix: "%", label: "Avg. freight cost reduction*", testid: "stat-cost-reduction" },
    { value: 9, suffix: "+", label: "Logistics gaps closed", testid: "stat-gaps" },
    { value: 5, suffix: "", label: "AU ports covered day-one", testid: "stat-ports" },
    { value: 24, suffix: "/7", label: "Live shipment monitoring", testid: "stat-monitoring" },
];

export default function Stats() {
    const [ref, visible] = useReveal();
    return (
        <section
            data-testid="stats-section"
            className="relative border-t border-white/5 py-16 sm:py-20"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
                    {STATS.map((s) => (
                        <Counter key={s.testid} {...s} active={visible} />
                    ))}
                </div>
                <p className="text-[10px] font-mono-accent text-zinc-600 mt-5 text-center">
                    *INDICATIVE BASED ON FREIGHT COST AUDITS &amp; LANE BENCHMARKING ENGAGEMENTS
                </p>
            </div>
        </section>
    );
}

function Counter({ value, suffix, label, active, testid }) {
    const [n, setN] = useState(0);
    const started = useRef(false);
    useEffect(() => {
        if (!active || started.current) return;
        started.current = true;
        const duration = 1400;
        const start = performance.now();
        const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.round(eased * value));
            if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    }, [active, value]);

    return (
        <div data-testid={testid} className="bg-[#0A0A0E] p-7 sm:p-9">
            <div className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter">
                {n}
                <span className="text-cyan-400">{suffix}</span>
            </div>
            <div className="text-xs sm:text-sm text-zinc-500 mt-3 font-mono-accent uppercase tracking-[0.16em]">
                {label}
            </div>
        </div>
    );
}
